const GOVERNANCE_DESCRIPTION = `Overall Governance scores out of 100, and then broken down by Shareholders, Management, and Corporate Social Responsibility Strategy. The higher the score the better.`;

export default GOVERNANCE_DESCRIPTION;
